export function getCssVariable(documentElement: HTMLElement, name: string): number {
  const value = getComputedStyle(documentElement).getPropertyValue(name).trim();

  return parseFloat(value) || 0;
}
